var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 10.0002C2.6665 10.0002 3.33317 9.3335 5.33317 9.3335C7.33317 9.3335 8.6665 10.6668 10.6665 10.6668C12.6665 10.6668 13.3332 10.0002 13.3332 10.0002V2.00016C13.3332 2.00016 12.6665 2.66683 10.6665 2.66683C8.6665 2.66683 7.33317 1.3335 5.33317 1.3335C3.33317 1.3335 2.6665 2.00016 2.6665 2.00016L2.6665 14.6668",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.77ed7688ae98f86dcb204cb7a22a2883.svg";
export { ForwardRef as ReactComponent };